import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, NavLink } from 'react-router-dom';
import Responsive from 'react-responsive';

const Mobile = props => <Responsive {...props} maxWidth={767} />;
const Default = props => <Responsive {...props} minWidth={768} />;

const Tabs = ({ history, location, sections }) => (
  <div>
    <Mobile>
      <select
        value={location.pathname}
        className="tabs-select"
        onChange={e => history.push(e.target.value)}
      >
        {sections.map((section, index) => (
          <option key={index} value={section.path}>
          
            {section.title}
            {section.badge && ` (${section.badge})`}
          </option>
        ))}
      </select>
    </Mobile>
    <Default>
      <div className="bx--content-switcher overflow">
        {sections.map((section, index) => (
          <NavLink
            key={index}
            to={section.path}
            className="bx--content-switcher-btn tabs-text"
            activeClassName="bx--content-switcher--selected tabs-text"
            role="button"
            exact
          >
            {section.title}
            {!!section.badge && <span className="bx--tag bx--tag--custom">{section.badge}</span>}
          </NavLink>
        ))}
      </div>
    </Default>
  </div>
);
Tabs.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
};
Tabs.defaultProps = {
  sections: [],
};

const TabsWithRouter = withRouter(Tabs);

export default TabsWithRouter;



// WEBPACK FOOTER //
// ./src/components/Tabs.js